const mediaItems = [
  {
    title: '顶流艺人酒店密会全程时间线复盘',
    duration: '12:35',
    views: '128万',
    img: 'https://readdy.ai/api/search-image?query=Dramatic%20video%20thumbnail%20style%20with%20play%20button%20overlay%2C%20warm%20crimson%20tones%2C%20luxury%20hotel%20ambience%2C%20editorial%20design%2C%20cinematic%20mood%2C%20no%20text%2C%20professional%20quality&width=800&height=500&seq=media-01&orientation=landscape',
  },
  {
    title: '知名网红直播现场翻车完整回放',
    duration: '08:22',
    views: '96万',
    img: 'https://readdy.ai/api/search-image?query=Video%20thumbnail%20style%20with%20play%20icon%2C%20live%20streaming%20studio%20scene%2C%20warm%20amber%20lighting%2C%20chaotic%20mood%2C%20editorial%20design%2C%20no%20text%2C%20professional%20quality&width=800&height=500&seq=media-02&orientation=landscape',
  },
  {
    title: '综艺录制现场冲突原声视频首曝',
    duration: '05:47',
    views: '85万',
    img: 'https://readdy.ai/api/search-image?query=Video%20thumbnail%20with%20play%20icon%2C%20TV%20studio%20stage%2C%20dramatic%20spotlight%2C%20warm%20golden%20tones%2C%20editorial%20design%2C%20no%20text%2C%20professional%20quality&width=800&height=500&seq=media-03&orientation=landscape',
  },
  {
    title: '豪门婚变独家采访当事人亲友',
    duration: '15:10',
    views: '73万',
    img: 'https://readdy.ai/api/search-image?query=Video%20thumbnail%20style%20with%20play%20button%2C%20luxury%20mansion%2C%20warm%20crimson%20and%20gold%20tones%2C%20editorial%20design%2C%20dramatic%20mood%2C%20no%20text%2C%20professional%20quality&width=800&height=500&seq=media-04&orientation=landscape',
  },
  {
    title: '娱乐圈税务大整顿全解读专题',
    duration: '20:05',
    views: '67万',
    img: 'https://readdy.ai/api/search-image?query=Video%20thumbnail%20with%20play%20icon%2C%20modern%20office%20building%20dramatic%20sky%2C%20warm%20sunset%20tones%2C%20editorial%20design%2C%20no%20text%2C%20professional%20quality&width=800&height=500&seq=media-05&orientation=landscape',
  },
];

export default function MediaSection() {
  return (
    <section id="media" className="py-14 md:py-20 bg-background-100">
      <div className="max-w-[1280px] mx-auto px-4 md:px-6">
        <div className="text-center mb-10 md:mb-14">
          <h2 className="text-2xl md:text-4xl font-heading text-foreground-950 mb-3">
            热门视频
          </h2>
          <p className="text-sm md:text-base text-foreground-600 max-w-[600px] mx-auto">
            全网最火爆的51吃瓜黑料视频在线观看
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5 md:gap-6">
          {mediaItems.slice(0, 3).map((item, i) => (
            <a
              key={i}
              href="#ranking"
              className="group block rounded-xl overflow-hidden bg-background-50 border border-background-200/50 hover:border-primary-200 transition-all duration-200 cursor-pointer"
            >
              <div className="relative aspect-[16/10] overflow-hidden bg-background-200">
                <img
                  src={item.img}
                  alt={item.title}
                  className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-400"
                />
                <div className="absolute inset-0 flex items-center justify-center">
                  <div className="w-14 h-14 rounded-full bg-primary-500/90 flex items-center justify-center group-hover:bg-primary-500 transition-colors duration-200">
                    <i className="ri-play-fill text-2xl text-background-50 ml-0.5"></i>
                  </div>
                </div>
                <div className="absolute bottom-3 right-3 px-2.5 py-1 rounded-lg bg-black/70 text-background-50 text-xs font-medium">
                  {item.duration}
                </div>
              </div>
              <div className="p-4">
                <h3 className="text-sm font-bold text-foreground-900 mb-2 line-clamp-2 group-hover:text-primary-500 transition-colors duration-200">
                  {item.title}
                </h3>
                <div className="flex items-center gap-3 text-xs text-foreground-500">
                  <span className="flex items-center gap-1">
                    <i className="ri-eye-line"></i>
                    {item.views}次播放
                  </span>
                </div>
              </div>
            </a>
          ))}
          {mediaItems.slice(3).map((item, i) => (
            <a
              key={i + 3}
              href="#ranking"
              className="group lg:col-span-3 flex flex-col lg:flex-row rounded-xl overflow-hidden bg-background-50 border border-background-200/50 hover:border-primary-200 transition-all duration-200 cursor-pointer"
            >
              <div className="relative w-full lg:w-[400px] flex-shrink-0 aspect-[16/10] lg:aspect-auto overflow-hidden bg-background-200">
                <img
                  src={item.img}
                  alt={item.title}
                  className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-400"
                />
                <div className="absolute inset-0 flex items-center justify-center">
                  <div className="w-14 h-14 rounded-full bg-primary-500/90 flex items-center justify-center group-hover:bg-primary-500 transition-colors duration-200">
                    <i className="ri-play-fill text-2xl text-background-50 ml-0.5"></i>
                  </div>
                </div>
                <div className="absolute bottom-3 right-3 px-2.5 py-1 rounded-lg bg-black/70 text-background-50 text-xs font-medium">
                  {item.duration}
                </div>
              </div>
              <div className="flex-1 p-5 lg:p-6 flex flex-col justify-center">
                <h3 className="text-sm md:text-base font-bold text-foreground-900 mb-2 group-hover:text-primary-500 transition-colors duration-200">
                  {item.title}
                </h3>
                <div className="flex items-center gap-3 text-xs text-foreground-500">
                  <span className="flex items-center gap-1">
                    <i className="ri-eye-line"></i>
                    {item.views}次播放
                  </span>
                  <span className="flex items-center gap-1">
                    <i className="ri-time-line"></i>
                    {item.duration}
                  </span>
                </div>
              </div>
            </a>
          ))}
        </div>
      </div>
    </section>
  );
}